<template>
  <div class="selectLocationPage areaPage">
    <van-tabs v-model="active" swipeable class="areaTab" @click="onCheck">
      <van-tab
        title="市级"
        name="city"
        class="tabList"
        v-if="locationSource.gridLevel == '1'"
      >
        <div class="cityBox">
          <!-- 没有数据 -->
          <p class="kongSoure" v-if="cityData == ''">无匹配数据</p>
          <van-radio-group v-model="cityRadio">
            <van-cell-group>
              <van-cell
                v-for="(item, index) in cityData"
                :key="item.code"
                :title="`${item.zqName}`"
                clickable
                @click="getAreaData(active, item, index)"
              >
                <van-radio
                  slot="right-icon"
                  checked-color="#4ac08a"
                  :name="index"
                />
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>
      </van-tab>
      <van-tab
        title="县/区级"
        name="area"
        class="tabList"
        v-if="
          locationSource.gridLevel == '1' || locationSource.gridLevel == '2'
        "
      >
        <div class="areaBox">
          <!-- 没有数据 -->
          <p class="kongSoure" v-if="areaData == ''">无匹配数据</p>
          <van-radio-group v-model="areaRadio">
            <van-cell-group>
              <van-cell
                v-for="(item, index) in areaData"
                :key="item.code"
                :title="`${item.zqName}`"
                clickable
                @click="getTownshipData(active, item, index)"
              >
                <van-radio
                  slot="right-icon"
                  checked-color="#4ac08a"
                  :name="index"
                />
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>
      </van-tab>
      <van-tab
        title="镇/乡级"
        name="township"
        class="tabList"
        v-if="
          locationSource.gridLevel == '1' ||
          locationSource.gridLevel == '2' ||
          locationSource.gridLevel == '3'
        "
      >
        <div class="townshipBox">
          <!-- 没有数据 -->
          <p class="kongSoure" v-if="townshipData == ''">无匹配数据</p>
          <van-radio-group v-model="townshipRadio">
            <van-cell-group>
              <van-cell
                v-for="(item, index) in townshipData"
                :key="item.code"
                :title="`${item.zqName}`"
                clickable
                @click="getvillageData(active, item, index)"
              >
                <van-radio
                  slot="right-icon"
                  checked-color="#4ac08a"
                  :name="index"
                />
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>
      </van-tab>
      <van-tab
        title="村级"
        name="village"
        class="tabList"
        v-if="
          locationSource.gridLevel == '1' ||
          locationSource.gridLevel == '2' ||
          locationSource.gridLevel == '3' ||
          locationSource.gridLevel == '4'
        "
      >
        <div class="areaBox">
          <!-- 没有数据 -->
          <p class="kongSoure" v-if="villageData == ''">无匹配数据</p>
          <van-radio-group v-model="villageRadio">
            <van-cell-group>
              <van-cell
                v-for="(item, index) in villageData"
                :key="item.code"
                :title="`${item.zqName}`"
                clickable
                @click="getcheck(item, index)"
              >
                <van-radio
                  slot="right-icon"
                  checked-color="#4ac08a"
                  :name="index"
                />
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>
      </van-tab>
    </van-tabs>
    <div class="checkedValue">
      <van-cell-group>
        <van-field
          v-model="checkedValue"
          rows="1"
          readonly
          autosize
          label="选中值："
          type="textarea"
          placeholder
        />
      </van-cell-group>
    </div>
    <!-- 操作按钮 -->
    <div class="btnBox clearfix">
      <a href="javascript:void(0);" class="closeBtn" @click="closePicker(1)"
        >取消</a
      >
      <a href="javascript:void(0);" class="sureBtn" @click="closePicker(2)"
        >确定</a
      >
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
import { mapState } from "vuex";
export default {
  name: "selectLocation",
  data() {
    return {
      active: "province",

      provinceData: "", //省数据源
      cityData: "", //市数据源
      areaData: "", //区数据源
      townshipData: "", //乡镇数据源
      villageData: "", //村数据源
      checkedValue: "", //选中值
      checkedCode: "",
      checkedLevel: "",
      provinceRadio: "", //省选中高亮
      cityRadio: "", //市选中高亮
      areaRadio: "", //区选中高亮
      townshipRadio: "", //乡镇选中高亮
      villageRadio: "", //村选中高亮
      showKong: false, //没有内容展示
    };
  },
  props: {
    locationSource: {
      type: Object,
      default: () => ({}),
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.locationSource.zqName && this.locationSource.zqCode) {
        this.checkedLevel = this.locationSource.gridLevel;
        this.checkedValue = this.locationSource.zqName;
        if (this.checkedLevel == "1") {
          this.getSourceData("city", this.locationSource.zqCode); //加载全国市级数据
        } else if (this.checkedLevel == "2") {
          this.getSourceData("area", this.locationSource.zqCode); //加载区级数据
        } else if (this.checkedLevel == "3") {
          this.getSourceData("township", this.locationSource.zqCode); //加载乡镇数据
        } else {
          this.getSourceData("village", this.locationSource.zqCode); //加载村级数据
        }
      }
    });
  },
  methods: {
    closePicker(type) {
      let data = {
        zqName: this.checkedValue,
        zqCode: this.checkedCode
          ? this.checkedCode
          : this.locationSource.zqCode,
        gridLevel: this.checkedLevel,
      };
      console.log(data);
      this.$emit("setData", data);
    },
    getSourceData(name, parentCode) {
      let _this = this;
      console.log(name);
      _this.$api.User.areaList({
        parentCode: parentCode,
        regionLevel: _this.checkedLevel,
      })
        .then((res) => {
          if (res.code == "1") {
            if (res.data == [] || res.data == "") {
              _this.showKong = true;
            }

            if (name == "city") {
              //市级
              let resetData = [
                {
                  zqCode: res.data.zqCode
                    ? res.data.zqCode
                    : _this.locationSource.zqCode,
                  zqName: "重置选择",
                },
              ];
              _this.cityData = resetData.concat(res.data.children);
              if (_this.locationSource.zqCode) {
                let cityCode = _this.locationSource.zqCode;
                _this.cityData.forEach((item, index) => {
                  if (cityCode === _this.cityData[index].zqCode) {
                    _this.cityRadio = index;
                  }
                });
              }
            } else if (name == "area") {
              //区级
              let resetData = [
                {
                  zqCode: res.data.zqCode
                    ? res.data.zqCode
                    : _this.locationSource.zqCode,
                  zqName: "重置选择",
                },
              ];
              _this.areaData = resetData.concat(res.data.children);
              if (_this.locationSource.zqCode) {
                let areaCode = _this.locationSource.zqCode;
                _this.areaData.forEach((item, index) => {
                  if (areaCode === _this.areaData[index].code) {
                    _this.areaRadio = index;
                  }
                });
              }
            } else if (name == "township") {
              //乡镇级
              console.log();
              let resetData = [
                {
                  zqCode: res.data.zqCode
                    ? res.data.zqCode
                    : _this.locationSource.zqCode,
                  zqName: "重置选择",
                },
              ];
              _this.townshipData = resetData.concat(res.data.children);
              if (_this.locationSource.zqCode) {
                let townshipCode = _this.locationSource.zqCode;
                _this.townshipData.forEach((item, index) => {
                  if (townshipCode === _this.townshipData[index].code) {
                    _this.townshipRadio = index;
                  }
                });
              }
            } else if (name == "village") {
              //村级
              let resetData = [
                {
                  zqCode: res.data.zqCode
                    ? res.data.zqCode
                    : _this.locationSource.zqCode,
                  zqName: "重置选择",
                },
              ];
              _this.villageData = resetData.concat(res.data.children);
              if (_this.locationSource.zqCode) {
                let villageCode = _this.locationSource.zqCode;
                _this.villageData.forEach((item, index) => {
                  if (villageCode === _this.villageData[index].code) {
                    _this.villageRadio = index;
                  }
                });
              }
            } else {
              return;
            }
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getAreaData(name, item, index) {
      //选择市级
      console.log(item);
      let _this = this;
      _this.cityRadio = index;
      _this.active = "area";
      _this.townshipData = "";
      _this.villageData = "";
      _this.areaRadio = ""; //区选中高亮
      _this.townshipRadio = ""; //乡镇选中高亮
      _this.villageRadio = ""; //村选中高亮

      let changeValue = _this.checkedValue.split("/");
      if (item.zqName === "重置选择") {
        if (_this.checkedCode.length > 2) {
          _this.checkedCode = _this.checkedCode.substr(0, 2);
          _this.checkedValue = changeValue[0];
        } else {
          _this.checkedValue = changeValue.join("/");
        }

        _this.areaData = [];
        _this.villageData = [];
        _this.townshipData = [];
      } else {
        if (_this.locationSource.gridLevel == "1") {
          _this.checkedValue = changeValue[0] + "/" + item.zqName;
        } else {
          _this.checkedValue = changeValue.splice(0, 1) + "/" + item.zqName;
        }
        _this.checkedCode = item.zqCode;
        _this.checkedLevel = "2";
        _this.getSourceData(_this.active, item.zqCode);
      }
    },
    getTownshipData(name, item, index) {
      //选择区级
      let _this = this;
      _this.areaRadio = index;
      _this.active = "township";
      _this.villageData = "";

      _this.townshipRadio = ""; //乡镇选中高亮
      _this.villageRadio = ""; //村选中高亮
      let changeValue = _this.checkedValue.split("/");
      console.log(_this.checkedValue);
      if (item.zqName === "重置选择") {
        if (_this.checkedCode.length > 4) {
          _this.checkedCode = _this.checkedCode.substr(0, 4);
          console.log(_this.checkedCode);
          _this.checkedValue = changeValue
            .splice(0, changeValue.length - 1)
            .join("/");
        } else {
          _this.checkedValue = changeValue.join("/");
        }

        _this.villageData = [];
        _this.townshipData = [];
      } else {
        if (_this.locationSource.gridLevel == "2") {
          _this.checkedValue = changeValue[0] + "/" + item.zqName;
        } else {
          _this.checkedValue =
            changeValue.splice(0, 2).join("/") + "/" + item.zqName;
        }
        _this.checkedCode = item.zqCode;
        _this.checkedLevel = "3";
        _this.getSourceData(_this.active, item.zqCode);
      }
    },
    getvillageData(name, item, index) {
      //选择乡镇级
      let _this = this;
      _this.townshipRadio = index;
      let changeValue = _this.checkedValue.split("/");
      if (item.zqName === "重置选择") {
        if (_this.checkedCode.length > 6) {
          _this.checkedCode = _this.checkedCode.substr(0, 6);
          console.log(_this.checkedCode);
          _this.checkedValue = changeValue
            .splice(0, changeValue.length - 1)
            .join("/");
        } else {
          _this.checkedValue = changeValue.join("/");
        }
        _this.villageData = [];
      } else {
        _this.active = "village";
        _this.villageRadio = ""; //村选中高亮

        if (_this.locationSource.gridLevel == "2") {
          _this.checkedValue =
            changeValue.splice(0, 2).join("/") + "/" + item.zqName;
        } else if (_this.locationSource.gridLevel == "3") {
          _this.checkedValue = changeValue[0] + "/" + item.zqName;
        } else {
          _this.checkedValue =
            changeValue.splice(0, 3).join("/") + "/" + item.zqName;
        }

        _this.checkedLevel = "4";
        _this.checkedCode = item.zqCode;
        _this.getSourceData(_this.active, item.zqCode);
      }
    },
    getcheck(item, index) {
      //选择村级
      let _this = this;
      _this.villageRadio = index;
      _this.checkedValue = _this.checkedValue.split("/");
      console.log(item);
      if (item.zqName === "重置选择") {
        if (_this.checkedCode.length > 9) {
          _this.checkedValue = _this.checkedValue
            .splice(0, _this.checkedValue.length - 1)
            .join("/");
        } else {
          _this.checkedValue = _this.checkedValue.join("/");
        }
      } else {
        if (_this.locationSource.gridLevel == "2") {
          _this.checkedValue =
            _this.checkedValue.splice(0, 3).join("/") + "/" + item.zqName;
        } else if (_this.locationSource.gridLevel == "3") {
          _this.checkedValue =
            _this.checkedValue.splice(0, 2).join("/") + "/" + item.zqName;
        } else if (_this.locationSource.gridLevel == "4") {
          _this.checkedValue = _this.checkedValue[0] + "/" + item.zqName;
        } else {
          _this.checkedValue =
            _this.checkedValue.splice(0, 4).join("/") + "/" + item.zqName;
        }

        _this.checkedCode = item.zqCode;
        _this.checkedLevel = "5";
      }
    },
    onCheck(name, title) {
      console.log(title);
    },
  },
  computed: {
    ...mapState(["userinfo"]),
  },
  watch: {
    locationSource: {
      handler: function () {
        this.checkedLevel = this.locationSource.gridLevel;
        if (this.checkedLevel == "1") {
          this.getSourceData("city", this.locationSource.zqCode); //加载全国市级数据
        } else if (this.checkedLevel == "2") {
          this.getSourceData("area", this.locationSource.zqCode); //加载区级数据
        } else if (this.checkedLevel == "3") {
          this.getSourceData("township", this.locationSource.zqCode); //加载乡镇数据
        } else {
          this.getSourceData("village", this.locationSource.zqCode); //加载村级数据
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.selectLocationPage {
  width: 100%;
  height: 100%;
  position: relative;

  .kongSoure {
    width: 100px;
    height: 50px;
    text-align: center;
    color: #333;
    font-size: 18px;
    position: absolute;
    top: 50%;
    margin-top: -25px;
    left: 50%;
    margin-left: -50px;
  }

  .areaTab.van-tabs {
    height: calc(100% - 90px);
    .van-tabs__wrap {
      height: 45px;
      .van-tabs__line {
        background-color: #4ac08a;
      }
    }

    .van-tabs__content {
      height: calc(100% - 45px);
      overflow-y: scroll;

      .provinceBox {
        .isChecked,
        .cityChecked {
          background-color: #4ac08a;
          color: #fff;

          .van-cell__right-icon {
            color: #fff;
          }
        }
      }
    }
  }

  .checkedValue {
    height: 45px;
    .van-cell-group {
      height: 100%;
      .van-cell {
        height: 100%;
        padding: 0 16px;
        .van-cell__title {
          text-align: center;
          span {
            line-height: 45px;
          }
        }
        .van-field__body {
          margin-top: 11px;
          textarea {
            height: 45px;
            overflow-y: scroll;
          }
        }
      }
    }

    .van-hairline--top-bottom::after,
    .van-hairline-unset--top-bottom::after {
      display: none;
    }
  }

  .btnBox {
    width: 100%;
    height: 45px;
    position: absolute;
    left: 0;
    bottom: 0;
    box-sizing: border-box;
    border-top: 1px solid #f6f6f6;

    a {
      display: inline-block;
      width: 50%;
      height: 45px;
      line-height: 45px;
      text-align: center;
      font-size: 16px;
      box-sizing: border-box;
    }

    .closeBtn {
      float: left;
      border-right: 1px solid #f6f6f6;
      color: rgb(235, 199, 155);
    }

    .sureBtn {
      float: right;

      color: #4ac08a;
    }
  }
}
</style>